import { type Session, useApiInspectionsV1Retrieve } from 'api';
import { useTranslation } from 'i18n';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Link, Typography } from 'ui';
import { ExpandMore } from 'ui/icons';

import { EvidenceInspectionSessionDetails } from '../EvidenceInspectionSessionDetails/EvidenceInspectionSessionDetails';
import { EvidenceSessionSummary } from '../EvidenceSessionSummary/EvidenceSessionSummary';

export const EvidenceInspectionSession = ({
  session,
  defaultExpanded = false,
}: {
  defaultExpanded?: boolean;
  session: Session;
}) => {
  const { t } = useTranslation('features');
  const { date, uploaded_by, parent_id, origin } = session;

  const { data: inspection } = useApiInspectionsV1Retrieve(Number(parent_id));

  if (!inspection) {
    return (
      <Accordion defaultExpanded={defaultExpanded} variant="outlined">
        <AccordionSummary expandIcon={<ExpandMore />}>
          <EvidenceSessionSummary date={date} uploadedBy={uploaded_by} origin={origin} />
        </AccordionSummary>
        <AccordionDetails>
          <Typography>{t('backlog.common.noData')}</Typography>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <Accordion defaultExpanded={defaultExpanded} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <EvidenceSessionSummary date={date} uploadedBy={uploaded_by} origin={origin} />
      </AccordionSummary>
      <AccordionDetails>
        <EvidenceInspectionSessionDetails
          slug={inspection.slug}
          deal={inspection.deal}
          linkToExternalReport={inspection.external_report_link}
          currentStatus={inspection.status}
        />
      </AccordionDetails>
      <AccordionActions>
        <Link href={`/ground-control/inspections/${parent_id}`} target="_blank">
          {t('backlog.evidence.common.manageInspection')}
        </Link>
      </AccordionActions>
    </Accordion>
  );
};
